import type { HTMLAttributes, ReactElement } from 'react';

import { classNames } from '@m1work/shared-utils';

import styles from './Container.module.scss';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * Centres the page content and limits its width (1600px), with page side padding that grows with the screen.
 *
 * @example
 * <Container>{children}</Container>
 */
export function Container({ className, children, ...props }: ContainerProps): ReactElement {
    return (
        <div className={classNames(styles.container, className)} {...props}>
            {children}
        </div>
    );
}
